import React from "react"
//import styled from 'styled-components'

import tw, { styled } from "twin.macro"

const Field = ({ name, ...props }) => (
  <Style className="form-type-textfield form-field form-field--textfield">
    <input
      type="text"
      defaultValue={props.reference ? "" : props.defaultValue}
      name={name}
      key={`XXX---${props.id}`}
      id={props.id}
      required={props.required}
      placeholder={props.placeholder}
      ref={props.reference}
      minLength={props.minLength || null}
      maxLength={props.maxLength || null}
      size={props.size || null}
      pattern={props.pattern || null}
      onChange={props.reference ? null : props.onChange}
      disabled={props.disabled || false}
      inputMode={props.inputMode || "text"}
    />
    <label htmlFor={props.id}>{props.title}</label>
    {props.description && (
      <div
        className="description"
        dangerouslySetInnerHTML={{ __html: props.description }}
      />
    )}
  </Style>
)

export default Field

const Style = styled.div`
  ${tw`
        gap-y-2
        grid
        grid-cols-1
    `}

  > label {
    font-size: 1.25em;
    ${tw`row-start-1 font-semibold`}
  }

  > input {
    ${tw`row-start-2 w-full outline-none appearance-none`}
    height: 60px;
    padding: 0.85em 0;
    font-size: 1.25em;
    border-radius: 0.15em;
    border: 1px solid rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1em rgba(0, 0, 0, 0.15);
    text-indent: 0.85em;

    &:focus,
    &:focus-visible {
      border-left: 7px solid var(--nova-pink);

      ~ label {
        ${tw`text-pink`}
      }

      &:valid {
        border-color: var(--nova-green);

        ~ label {
          color: var(--nova-green);
        }
      }
    }

    &:focus-visible {
      border-color: var(--nova-pink);
    }

    &[required] + label::after {
      content: "*";
      margin-left: 0.1em;
    }
  }

  .description {
    font-size: 13px;
    order: -1;
  }
`
